import type { HTMLAttributes } from "react";
import clsx from "clsx";

export const Badge = ({
  className,
  ...props
}: HTMLAttributes<HTMLSpanElement>) => (
  <span
    className={clsx(
      "inline-flex items-center rounded-pill px-3 py-1 text-caption font-semibold",
      "bg-primary/10 text-content-accent",
      className,
    )}
    {...props}
  />
);

export default Badge;
